import { IIconProps } from './add';

export const IcoPencilEditStudy: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    data-cy={`IcoPencilEditStudy${cy}`}
  >
    <path
      d="M8.54402 4.765L9.23402 5.455L2.43902 12.25H1.74902V11.56L8.54402 4.765ZM11.244 0.25C11.0565 0.25 10.8615 0.325 10.719 0.4675L9.34652 1.84L12.159 4.6525L13.5315 3.28C13.824 2.9875 13.824 2.515 13.5315 2.2225L11.7765 0.4675C11.6265 0.3175 11.439 0.25 11.244 0.25ZM8.54402 2.6425L0.249023 10.9375V13.75H3.06152L11.3565 5.455L8.54402 2.6425Z"
      fill="currentColor"
    />
  </svg>
);
